import { gql } from "@apollo/client"

const GET_GROUP_SLOTS = gql`
  query($id: ID) {
    group(id: $id) {
      id
      slots {
        id
        starts_at
        ends_at
        status
      }
    }
  }
`

export { GET_GROUP_SLOTS }